import { put, select, takeEvery } from 'redux-saga/effects'
import { sagaActions as rootSagaActions } from 'store/sagas'
import { CHANNEL_DATA } from 'CHANNEL_DATA'
import { push } from 'index'

function * channelData ({ cardId }, action) {
  const { channel, actionName, elementName, data } = action.payload

  const state = yield select()

  const boardId = state['view-board'].cards[cardId].boardId

  const currentUserId = state.kanbo.currentUser.id

  if (channel === 'card-' + cardId) {
    if (actionName + elementName === 'RemoveCard/Data/Card') {
      yield put(push('/board/' + boardId))
    }
  } else if (channel === '@' + currentUserId) {
    if (actionName + elementName === 'AddNotification/Data/Notification') {
      const { Id, Tags } = data

      if (Tags.indexOf('card-' + cardId) !== -1) {
        yield put(rootSagaActions.requestMarkNotificationAsRead({
          id: Id
        }))
      }
    }
  }
}

export default function * viewChannelData (context) {
  yield takeEvery(CHANNEL_DATA, channelData, context)
}
